"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var hub_1 = require("@sentry/hub");

var path_1 = require("@sentry/utils/path");
/** Rewrite event frames paths */


var RewriteFrames =
/** @class */
function () {
  /**
   * @inheritDoc
   */
  function RewriteFrames(options) {
    if (options === void 0) {
      options = {};
    }

    var _this = this;
    /**
     * @inheritDoc
     */


    this.name = 'RewriteFrames';
    /**
     * @inheritDoc
     */

    this.iteratee = function (frame) {
      return __awaiter(_this, void 0, void 0, function () {
        var base;
        return __generator(this, function (_a) {
          if (frame.filename && frame.filename.startsWith('/')) {
            base = this.root ? path_1.relative(this.root, frame.filename) : path_1.basename(frame.filename);
            frame.filename = "app:///" + base;
          }

          return [2
          /*return*/
          , frame];
        });
      });
    };

    if (options.root) {
      this.root = options.root;
    }

    if (options.iteratee) {
      this.iteratee = options.iteratee;
    }
  }
  /**
   * @inheritDoc
   */


  RewriteFrames.prototype.install = function () {
    var _this = this;

    hub_1.getCurrentHub().configureScope(function (scope) {
      scope.addEventProcessor(function (event) {
        return __awaiter(_this, void 0, void 0, function () {
          return __generator(this, function (_a) {
            return [2
            /*return*/
            , this.process(event)];
          });
        });
      });
    });
  };
  /** JSDoc */


  RewriteFrames.prototype.process = function (event) {
    return __awaiter(this, void 0, void 0, function () {
      var frames, _a, _b, _i, i, _c, _d;

      return __generator(this, function (_e) {
        switch (_e.label) {
          case 0:
            frames = this.getFramesFromEvent(event);
            if (!frames) return [3
            /*break*/
            , 4];
            _a = [];

            for (_b in frames) {
              _a.push(_b);
            }

            _i = 0;
            _e.label = 1;

          case 1:
            if (!(_i < _a.length)) return [3
            /*break*/
            , 4];
            i = _a[_i]; // tslint:disable-next-line

            _c = frames;
            _d = i;
            return [4
            /*yield*/
            , this.iteratee(frames[i])];

          case 2:
            // tslint:disable-next-line
            _c[_d] = _e.sent();
            _e.label = 3;

          case 3:
            _i++;
            return [3
            /*break*/
            , 1];

          case 4:
            return [2
            /*return*/
            , event];
        }
      });
    });
  };
  /** JSDoc */


  RewriteFrames.prototype.getFramesFromEvent = function (event) {
    var exception = event.exception;

    if (exception) {
      try {
        // tslint:disable-next-line:no-unsafe-any
        return exception.values[0].stacktrace.frames;
      } catch (_oO) {
        return undefined;
      }
    } else if (event.stacktrace) {
      return event.stacktrace.frames;
    } else {
      return undefined;
    }
  };

  return RewriteFrames;
}();

exports.RewriteFrames = RewriteFrames;